<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">broken_image</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('missing.Missings') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>
                            <div class="col-lg-6 d-flex justify-content-end align-items-center gap-2">
                                <div class="btn-group" v-if="userRoleName == 'AssociationAdmin' || userRoleName == 'Keeper' ">
                                    <router-link
                                        :to="associationId ? { name: 'New Missing', params: { id: associationId } } : ''"
                                        class="btn btn-sm bg-gradient-success text-nowrap"
                                        :class="{ disabled: !associationId }"
                                        style="width: 185px;"
                                        >
                                    {{ $t('missing.Add_missing') }}
                                    </router-link>
                                </div>
                                <div class="btn-group" v-if="userRoleName === 'Admin'">
                                    <router-link
                                        class="btn btn-sm bg-gradient-success text-nowrap"                                        
                                        :to="associationId ? `/missing/create/${associationId}` : '#'"
                                        :class="{ disabled: !associationId }"
                                        style="width: 185px;"
                                    >
                                        {{ $t('missing.Add_missing') }}
                                    </router-link>

                                    <!-- Dropdown toggle -->
                                    <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="visually-hidden">{{ $t('settings.Select_association') }}</span>
                                    </button>

                                    <!-- Dropdown menu -->
                                    <ul class="dropdown-menu dropdown-menu-end  custom-association-dropdown">
                                        <li @click="associationId = ''">
                                            <span class="dropdown-item text-muted">
                                            {{ $t('settings.Select_association') }}
                                            </span>
                                        </li>
                                        <li><hr class="dropdown-divider" /></li>
                                        <li
                                            v-for="item in associations"
                                            :key="item.id"
                                            @click="associationId = item.id"
                                            class="dropdown-item"
                                        >
                                            {{ item.abbreviation }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">                                                
                        <table id="missing-list" class="table table-flush" v-if="tableVisible" >
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('missing.Animal_details') }}</p></th>                                    
                                </tr>
                            </thead>                            
                            <tbody>
                                <template v-for="(group, groupIndex) in groupedMissings" :key="groupIndex">
                                    <tr>
                                         <td colspan="9" class="bg-light text-muted small py-2">
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <span>
                                                   {{ $t('missing.Group') }} {{ groupIndex + 1 }} | {{ $t('missing.Missing_from_UBN') }}: {{ group[0].departureFromUBN }} | {{ $t('missing.Missing_reason') }}: {{ group[0].missingReasonName }} | {{ $t('missing.Date_of_missing') }}: {{ formatDate(group[0].occurrenceDate) }}
                                                </span>
                                                <div v-if="userRoleName != 'Keeper'">
                                                    <!-- Edit Group -->
                                                    <button style="margin-bottom: 0px !important;" :data-id="group[0].movementGroupId" class="btn btn-sm bg-gradient-success me-2 edit-button" :title="$t('common.Edit')">
                                                        <i class="material-symbols-rounded text-white" style="font-size: 0.8rem;">edit</i>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="item in group" :key="item.id">
                                        <td class="text-sm font-weight-normal">
                                            <span v-html="displayText(item)"></span>                                            
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <div class="d-flex justify-content-between align-items-center mt-3 ms-3 me-3 mb-5">
                            <div class="small text-muted">
                                Tonen
                                {{ totalGroups === 0 ? 0 : (currentPage - 1) * perPage + 1 }}
                                t/m
                                {{ Math.min(currentPage * perPage, totalGroups) }}
                                van
                                {{ totalGroups }}
                                items
                            </div>
                            <div class="btn-group pagination-circles">
                                <!-- Prev -->
                                <button
                                    class="page-circle"
                                    :class="{ disabled: currentPage === 1 }"
                                    @click="currentPage--"
                                    :disabled="currentPage === 1"
                                >
                                    ‹
                                </button>

                                <!-- Pages -->
                                <button
                                    v-for="p in totalPages"
                                    :key="p"
                                    class="page-circle"
                                    :class="{ active: p === currentPage }"
                                    @click="currentPage = p"
                                >
                                    {{ p }}
                                </button>

                                <!-- Next -->
                                <button
                                    class="page-circle"
                                    :class="{ disabled: currentPage === totalPages }"
                                    @click="currentPage++"
                                    :disabled="currentPage === totalPages"
                                >
                                    ›
                                </button>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'Missing_index_page',
    components: {
    },
    data() {
        return {
            associationId: '',
            associations: [],
            missings: [],
            gets: [],            
            dataTableInstance: null,
            tableVisible: false,
            choicesInstanceAssociation: null,
            currentPage: 1,
            perPage: 5
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);            
            await this.loadMissings();

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    methods: { 
        displayText(f) {
            let parts = [];

            if (f.animalStudbookNumber) parts.push(f.animalStudbookNumber);
            if (f.animalNumber) parts.push(f.animalNumber);
            if (f.animalName) parts.push(`(${f.animalName})`);
            if (f.animalArrivalDate) {
                parts.push(`<span style="color: green">${f.animalArrivalDate}</span>`);
            }
            if (f.breedCode) parts.push(`(${f.breedCode})`);
            return parts.join(' | ');
        },
        async initDataTable() {

            await nextTick();

            const table = document.querySelector("#missing-list");
            if (!table || !table.parentNode) {
                console.warn("Table or its parent not found. Skipping DataTable init.");
                return;
            }

            if (this.dataTableInstance) {
                this.dataTableInstance.destroy();
                this.dataTableInstance = null;
            }

            this.dataTableInstance = new DataTable("#missing-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                info: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },                                                         
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    //perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    //info: `Tonen {start} t/m {end} van ${this.groupedMissings.length} items`,
                    placeholder: this.$t('common.Search') 
                }
            });  

            // helper to compute and write the info text based on groups
            const vm = this;
            const ensureBottomExists = () => {
                // simple-datatables wraps the table with an element having class "dataTable-wrapper"
                const wrapper = table.parentElement.querySelector('.dataTable-wrapper') || table.closest('.dataTable-wrapper');
                if (!wrapper) return null;

                let bottom = wrapper.querySelector('.dataTable-bottom');
                if (!bottom) {
                    bottom = document.createElement('div');
                    bottom.className = 'dataTable-bottom';
                    // place bottom at end of wrapper
                    wrapper.appendChild(bottom);
                }

                let infoEl = bottom.querySelector('.dataTable-info');
                if (!infoEl) {
                    infoEl = document.createElement('div');
                    infoEl.className = 'dataTable-info';
                    bottom.prepend(infoEl);
                }
                return infoEl;
            };

            const updateInfoText = () => {
                try {
                    const groupsCount = Array.isArray(vm.groupedMissings) ? vm.groupedMissings.length : 0;

                    // ensure the bottom/info elements exist
                    const infoEl = ensureBottomExists();
                    if (!infoEl) return;

                    if (groupsCount === 0) {
                        infoEl.textContent = vm.$t('datatable.NoRows') || 'Tonen 0 t/m 0 van 0 items';
                        return;
                    }

                    // --- Safely determine perPage (coerce to integer)
                    const perPageRaw = (vm.dataTableInstance && vm.dataTableInstance.options && vm.dataTableInstance.options.perPage)
                        ? vm.dataTableInstance.options.perPage
                        : (vm.dataTableInstance && vm.dataTableInstance.perPage) ? vm.dataTableInstance.perPage : null;

                    let perPage = parseInt(perPageRaw, 10);
                    if (!Number.isFinite(perPage) || perPage <= 0) {
                        // fallback: show all groups on a single page to avoid NaN
                        perPage = groupsCount;
                    }

                    // --- Safely determine current page (1-based)
                    let currentPage = 1;
                    try {
                        if (typeof vm.dataTableInstance.page === 'function') {
                            const p = vm.dataTableInstance.page();
                            currentPage = Number.isFinite(+p) && +p >= 1 ? Math.floor(+p) : 1;
                        } else if (Number.isFinite(+vm.dataTableInstance.currentPage) && +vm.dataTableInstance.currentPage >= 1) {
                            currentPage = Math.floor(+vm.dataTableInstance.currentPage);
                        }
                    } catch (e) {
                        currentPage = 1;
                    }

                    // If computed start is outside total groups, clamp to last page
                    let start = ((currentPage - 1) * perPage) + 1;
                    if (start > groupsCount) {
                        // move to last page
                        currentPage = Math.max(1, Math.ceil(groupsCount / perPage));
                        start = ((currentPage - 1) * perPage) + 1;
                    }

                    const end = Math.min(start + perPage - 1, groupsCount);

                    const infoText = `Tonen ${start} t/m ${end} van ${groupsCount} items`;
                    infoEl.textContent = infoText;
                } catch (err) {
                    // swallow errors so UI doesn't break
                    // console.warn('updateInfoText error', err);
                }
            };

            // Hook up events
            this.dataTableInstance.on('datatable.init', () => {
                // give the table a tick to let the library finish building wrappers, then update
                setTimeout(updateInfoText, 0);
            });
            this.dataTableInstance.on('datatable.page', updateInfoText);
            this.dataTableInstance.on('datatable.perpage', updateInfoText);
            this.dataTableInstance.on('datatable.search', updateInfoText);
            this.dataTableInstance.on('datatable.refresh', updateInfoText);
            this.dataTableInstance.on('datatable.update', updateInfoText);

            // initial update (defer to ensure library DOM is ready)
            setTimeout(updateInfoText, 0);

            table.addEventListener('click', this.handleTableClick);
        },  
        handleTableClick(event) {
            
            const targetElement = event.target.closest('[data-id]');
            if (!targetElement) return;

            const id = targetElement.getAttribute('data-id');
            if (!id) return;

            if (event.target.closest('.edit-button')) {
                if (event.target.closest('tr').querySelector('td[colspan]')) {                                    
                    this.$router.push({ name: 'Edit Missing', params: { id: id }, query: { type: 'group' } });
                } else {
                    this.$router.push({ name: 'Edit Missing', params: { id: id }, query: { type: 'single' } });
                }       
            } else if (event.target.classList.contains('delete-button')) {
                if (event.target.closest('tr').querySelector('td[colspan]')) {                                        
                    this.deleteGroup(id);
                } else {                                        
                    this.deleteMissingModal(id);
                }
            }
        },
        async loadMissings() {
            try {

                let response;
                
                const role = this.$store.state.roleName;
                const keeperLocationId = this.$store.state.keeperLocationId;
                const keeperAssociationId = this.$store.state.keeperAssociationId;
                const associationAdminAssociationId = this.$store.state.associationAdminAssociationId;

                let associationId = this.$route.query.associationId
                let ubnId = this.$route.query.ubnId

                if (role === 'Keeper' && keeperLocationId && keeperAssociationId) {
                    ubnId = keeperLocationId;
                    associationId = keeperAssociationId;

                    this.ubnId = ubnId;
                    this.associationId = associationId;
                }

                if (role === 'AssociationAdmin') {                
                    associationId = associationAdminAssociationId;                
                    this.associationId = associationId;
                }

                if (role === 'Admin') {
                    await this.fetchAllAssociationData();
                    response = await axios.get("/missing/getall");
                } else if (role === 'AssociationAdmin') {                    
                    response = await axios.get(`/missing/getbyassociationubn?associationId=${associationId}&ubnId=`);
                } else if (role === 'Keeper' && ubnId) {
                    response = await axios.get(`/missing/getbyassociationubn?associationId=${associationId}&ubnId=${ubnId}`);
                } else {
                    // Optional: handle case where Keeper has no location selected
                    console.warn('No location assigned for Keeper');
                    return;
                }

                this.gets = response.data;

                if (!this.gets?.success) {
                    this.$showError('errors.Contact_system_admin');
                    return;
                }

                const rawData = Array.isArray(this.gets.data) ? this.gets.data : [];

                // 1. Destroy DataTable if it exists
                if (this.dataTableInstance) {
                    this.dataTableInstance.destroy();
                    this.dataTableInstance = null;
                }

                // 2. Force table unmount
                this.tableVisible = false;

                // 3. Wait for DOM update to unmount table
                await this.$nextTick();

                // 4. Set missings data
                this.missings = rawData;

                // 5. Force table mount
                this.tableVisible = true;

                // 6. Wait for DOM update to mount table
                await this.$nextTick();

                // 7. Init DataTable if data is present
                if (rawData.length > 0) {
                    this.initDataTable();
                } else {
                    this.initDataTable();
                    this.$showSuccess(this.$t('errors.No_missings_found'));
                }

            } catch (e) {
                console.error("Exception occurred in loadMissings()", e);
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
        },
        deleteGroup(groupGuid) {
            if (!groupGuid) {
                this.$showError('errors.Group_id_is_missing');
                return;
            }

            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_group'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete(`Missing/group/${groupGuid}`);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {

                                    this.$showSuccess('errors.Success_missing_group_deleted_successfully');
                                    await this.loadMissings();
                                    
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
                                }
                            } else {
                                this.$showError('errors.Contact_system_admin');
                            }
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                }); 
        },
        async fetchAllAssociationData() {
            try {
                const response = await axios.get("association/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data.associationList)) {
                    this.associations = result.data.associationList;
                } else {
                    this.$showError('errors.Error_fetching_associations');
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
            }
        },        
        async deleteMissingModal(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("Missing/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {
                                    const fetchResponse = await axios.get("Missing/getall");
                                    const fetchResult = fetchResponse.data;

                                    if (fetchResult.success) {

                                        this.missings = fetchResult.data;

                                        await nextTick();
                                        this.initDataTable();
                                        console.log('here');
                                        //if (this.dataTableInstance && typeof this.dataTableInstance.rows === 'function') {                                            
                                        //    this.dataTableInstance.rows().remove();                                            
                                        //} else {
                                        //    console.log('DataTable instance is not valid or not initialized');
                                        //}

                                        this.$showSuccess('errors.Success_record_is_deleted_successfully');                                        
                                    } else {
                                        throw new Error('Failed to fetch updated animal list.');
                                    }
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
                                }
                            } else {                                    
                                this.$showError('errors.Contact_system_admin');
                            }                            
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${'errors.Contact_system_admin'}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                });            
        }
    },
    computed: {
        allGroupedMissings() {
            const groups = {};

            this.missings.forEach(item => {
            let key = item.groupGuid;

            if (!key || typeof key !== 'string' || !key.trim()) {
                key = 'ungrouped';
            } else {
                key = key.trim().toLowerCase();
            }

            if (!groups[key]) {
                groups[key] = [];
            }

            groups[key].push(item);
            });

            return Object.values(groups); // all groups
        },
        groupedMissings() {
            const groups = {};

            this.missings.forEach(item => {
                let key = item.movementGroupId;
                
                if (!key || typeof key !== 'string' || !key.trim()) {
                    key = 'ungrouped';
                } else {
                    key = key.trim().toLowerCase();
                }

                if (!groups[key]) {
                    groups[key] = [];
                }

                groups[key].push(item);
            });

            return Object.values(groups); // Array of arrays
        },
        totalGroups() {
            return this.groupedMissings.length;
        },

        totalPages() {
            return Math.ceil(this.totalGroups / this.perPage);
        },
        userRoleName() {
            return this.$store.state.user?.roleName;
        }
    }
}
</script>
<style scoped>
    ::v-deep .dataTable-bottom {
        display: none !important;
    }

    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }

    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .pagination-circles {
        gap: 6px;
    }

    .page-circle {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #dee2e6;
        background: white;
        color: #6c757d;
        font-weight: 500;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
        padding: 0;
    }

    /* Hover */
    .page-circle:hover:not(.active):not(.disabled) {
        background-color: #f2f2f2;
    }

    /* Active page */
    .page-circle.active {
        background-color: #4ca750;   /* your green */
        color: white;
        border-color: #4ca750;
    }

    /* Disabled prev/next */
    .page-circle.disabled,
    .page-circle:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>